<template>
  <div class="top">
    <div class="top_box">
      <div class="top_left">
        <div :class="`title_icon top_left_symbol ${tlsymbol}`"></div>
        <h2 class="top_left_title">{{title}}</h2>
        <h2 class="top_left_title">{{title2}}</h2>
        <div class="top_left_subtitle">{{subtitle}}</div>   
        <A-Button :text='btn' @onclick="goLink(`https://platform.antdiy.vip/#/register?source=${source}`)"></A-Button>
      </div>
      <div class="top_right">
        <img :src="img" class="top_right_img" />
      </div>
    </div>
    <div :class='bg'></div>
  </div>
</template>

<script>
export default {
  name: 'topCN',
  props: ['title','title2', 'subtitle', 'content', 'btn', 'img', 'bg', 'tlcontent', 'tlsymbol'],
  data () {
    return {
      pageList: [
        {name: 'Productscn', link: 'productscn'},
      ],
      source: localStorage.getItem('ant_source') || ''
    }
  },
  methods: {
    goLink (url) {
      window.open(url)
    }
  },
}
</script>

<style scoped>
  .top{
    width: 100%;
    background: #fff;
    overflow: hidden;
    position: relative;
    background-image: linear-gradient(180deg, #FFD7CB 0%, #FFFFFF 100%, #FFFFFF 100%);
  }
  .top_box{
    width: 1200px;
    margin: 0 auto 0;
    height: 480px;
    display: flex;
    justify-content: space-between;
    position: relative;
    z-index: 1;
  }
  .top_left_symbol{
    margin: 68px 0 40px;
  }
  .top_left_title{
    font-family: SourceHanSansCN-Bold;
    font-size: 36px;
    color: #222536;
    line-height: 44px;
    font-weight: 700;
  }
  .top_left_subtitle{
    font-family: SourceHanSansCN-Regular;
    font-size: 18px;
    color: #222536;
    text-align: justify;
    line-height: 30px;
    font-weight: 400;
    margin: 38px 0 55px 0;
    width: 645px;
  }
  .top_right{
    width: 580px;
    margin-top: 21px;
  }
  .top_right_img{
    width: 580px;
    height: 459px;
  }
  .ad_button{
    width: 136px;
    height: 48px;
    background: #FC5322;
    box-shadow: 0px 6px 8px 0px rgba(252,83,34,0.1);
    border-radius: 4px;
    font-family: SourceHanSansCN-Medium;
    font-size: 16px;
    color: #FFFFFF;
    letter-spacing: 0.5px;
    font-weight: 500;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  @media (max-width: 767px){
    .top {
      background-image: none !important;
    }
    .top_box{
      width: 100%;
      height: auto;
      padding: .96rem .48rem .8rem;
      flex-direction: column;
    }
    .top_left{
      width: 100%;
      padding: 0;
    }
    .top_left_symbol{
      margin: .72rem 0 .4rem;
    }
    .ad_button{
      width: 100%;
      height: .96rem;
      box-shadow: 0 .09rem .12rem 0 rgba(252,83,34,0.1);
      border-radius: .08rem;
    }
    .title_icon{
      width: .36rem;
      height: .06rem;
      border-radius: .03rem;
    }
    .top_left_title{
      font-size: .4rem;
      letter-spacing: 0;
      line-height: .6rem;
    }
    .top_left_subtitle{
      margin: .23rem 0 .63rem;
      font-size: .28rem;
      letter-spacing: 0;
      line-height: .44rem;
      width: 100%;
    }
    .ad_button{
      width: 100%;
      text-align: center;
      border-radius: .08rem;
      font-size: .28rem;
      letter-spacing: .014rem;
    }
    .top_right{
      display: block;
      width: 100%;
      height: 5.41rem;
      margin-top: .57rem;
      background-image: linear-gradient(180deg, #FFD7CB 0%, #FFFFFF 100%, #FFFFFF 100%);
    }
    .top_right > img{
      width: 100%;
      height: 5.41rem;
      border-radius: .06rem;
    }
    .top_bg{
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/topCN.vue